import React from 'react'

function Navigation({display, setDisplay}) {
    const options = ['Wszystko', 'Bezpłatna konsultacja', 'Płatna konsultacja', 'Zadaj bezpłatne pytanie']
    let buttons_list = []

    options.forEach((option, index) => {
        buttons_list.push(
            <button className={`${index === display ? 'active' : ''}`} onClick={()=>setDisplay(index)} key={index}>{option}</button>
        )
    })
  return (
    <div id="stats-navigation">
        {buttons_list}
    </div>
  )
}

export default Navigation